import './ProductThumbnailsForSearch.css';
import mockProductImage from '../../img/product-image-thumbnail.svg';
import heartIcon from '../../img/heart-icon.svg';
import {useHistory} from 'react-router-dom';

const ProductThumbnails = ({id, productName, imageUrl, price}) => {

    const history = useHistory();

    const productDetailClickHandler = () => {
        history.push("/product/"+id)
    }

    return(
        <div onClick={productDetailClickHandler} className="productthumbnailsforsearch-wrapper">
            <div className="productthumbnailsforsearch-productdetails">
                <div className="productthumbnailsforsearch-productimagewrapper">
                    <img src={imageUrl}></img>
                </div>
                <div className="productthumbnailsforsearch-productinfo-wrapper">
                    <h6 id="productthumbnailsforsearch-productname">{productName}</h6>
                    <h5 id="productthumbnailsforsearch-productprice">Rp{price}</h5>
                </div>
                <div id="heart-icon">
                    <img src={heartIcon}></img>
                </div>
            </div>
        </div>
    )
    // return(
    //     <div className="productthumbnails-wrapper">
    //         <div className="productthumbnails-productdetails">
    //             <div className="productthumbnails-productimagewrapper">
    //                 <img src={mockProductImage}></img>
    //             </div>
    //             <div className="productthumbnails-productinfo-wrapper">
    //                 <h6 id="productthumbnails-productname">Nike Air Max React</h6>
    //                 <h5 id="productthumbnails-productprice">Rp500000</h5>
    //             </div>
    //             <div id="heart-icon">
    //                 <img src={heartIcon}></img>
    //             </div>
    //         </div>
    //     </div>
    // )
};

export default ProductThumbnails;